"use client";

import type { ReactElement, ReactNode } from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

type LongLabelTooltipSide = "top" | "right" | "bottom" | "left" | "inline-end" | "inline-start";
type LongLabelTooltipAlign = "start" | "center" | "end";

interface LongLabelTooltipProps {
  children: ReactElement;
  content: ReactNode;
  side?: LongLabelTooltipSide;
  align?: LongLabelTooltipAlign;
  contentClassName?: string;
}

function hasTooltipContent(content: ReactNode): boolean {
  if (typeof content === "string") {
    return content.trim().length > 0;
  }
  return content !== null && content !== undefined && content !== false;
}

export function LongLabelTooltip({
  children,
  content,
  side = "top",
  align = "center",
  contentClassName,
}: LongLabelTooltipProps) {
  if (!hasTooltipContent(content)) {
    return children;
  }

  return (
    <Tooltip>
      <TooltipTrigger render={children} />
      <TooltipContent side={side} align={align} className={contentClassName}>
        {content}
      </TooltipContent>
    </Tooltip>
  );
}
